import { render, staticRenderFns } from "./InventoryFlow.vue?vue&type=template&id=157a26f2&scoped=true"
import script from "./InventoryFlow.vue?vue&type=script&lang=js"
export * from "./InventoryFlow.vue?vue&type=script&lang=js"
import style1 from "./InventoryFlow.vue?vue&type=style&index=1&id=157a26f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a26f2",
  null
  
)

export default component.exports